'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.concat')
exports.__esModule = true
exports.default = void 0
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'))
var _assertThisInitialized2 = _interopRequireDefault(
  require('@babel/runtime/helpers/assertThisInitialized')
)
var _inheritsLoose2 = _interopRequireDefault(require('@babel/runtime/helpers/inheritsLoose'))
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _inherent = _interopRequireDefault(require('./inherent'))
var _utils = require('./utils')

/* eslint-disable class-methods-use-this */

/**
 * MonthVal
 *
 *
 * @class MonthVal
 * @extends {Inherent}
 * @implements {ValsInterface}
 *
 */ var MonthVal = /*#__PURE__*/ (function(_Inherent) {
  ;(0, _inheritsLoose2.default)(MonthVal, _Inherent)
  function MonthVal() {
    var _this
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key]
    }
    _this = _Inherent.call.apply(_Inherent, [this].concat(args)) || this
    ;(0, _defineProperty2.default)(
      (0, _assertThisInitialized2.default)(_this),
      'name',

      'month'
    )
    ;(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), 'firstChar', 'm')
    return _this
  }
  var _proto = MonthVal.prototype

  /**
   * @param {ValidStrType} str m0,2,5-7
   * @returns {ValidValType} [ 0, 2, 5, 6, 7]
   * @memberof MonthVal
   */ _proto.parseStr = function parseStr(str) {
    return (0, _utils.parseNumOrNumRangesStr)(str, this.firstChar)
  }

  /**
   * @param {ValidValType} val [ 0, 2, 5, 6, 7]
   * @returns {ValidStrType} m0,2,5-7
   * @memberof MonthVal
   */
  _proto.stringify = function stringify(val) {
    return (0, _utils.numsToStrWithCollapsing)(val, this.firstChar)
  }
  _proto.validateStr = function validateStr(str) {
    return (0, _utils.validateNumOrNumRangesStr)(str, this.firstChar) ? str : null
  }
  _proto.validateVal = function validateVal(val) {
    return (0, _utils.validateNumsArr)(val, 11) ? val : null
  }
  ;(0, _createClass2.default)(MonthVal, [
    {
      key: 'isAny',
      get: function get() {
        return (0, _utils.isAnyDefault)(this._val, 0, 11)
      }
    }
  ])
  return MonthVal
})(_inherent.default)
exports.default = MonthVal



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/TimingParser/month.js
// module id = 632
// module chunks = 0